/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Languages_TitleInputs */

const en_register_onboarding_personal_info_languages_title = /** @type {(inputs: Register_Onboarding_Personal_Info_Languages_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language skills`)
};

const de_register_onboarding_personal_info_languages_title = /** @type {(inputs: Register_Onboarding_Personal_Info_Languages_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachkenntnisse`)
};

/**
* | output |
* | --- |
* | "Language skills" |
*
* @param {Register_Onboarding_Personal_Info_Languages_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_languages_title = /** @type {((inputs?: Register_Onboarding_Personal_Info_Languages_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Languages_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_languages_title(inputs)
	return en_register_onboarding_personal_info_languages_title(inputs)
});